<!-- <div *ngIf="isLoading | async" class="loader-wrapper loadingio-spinner-eclipse-ymzi08ab7sf">
    <div class="ldio-54qn3masmm7">
        <div></div>
    </div>
</div> -->

<div *ngIf="isLoading | async" class="loader-wrapper loadingio-spinner-eclipse-yfpkut944xg">
    <div class="ldio-d90oa551ckl">
        <div></div>
    </div>
</div>
<style type="text/css">
    @keyframes ldio-d90oa551ckl {
        0% {
            transform: rotate(0deg)
        }

        50% {
            transform: rotate(180deg)
        }

        100% {
            transform: rotate(360deg)
        }
    }

    .ldio-d90oa551ckl div {
        position: absolute;
        animation: ldio-d90oa551ckl 0.4s linear infinite;
        width: 100px;
        height: 100px;
        top: 50px;
        left: 50px;
        border-radius: 50%;
        box-shadow: 0 4px 0 0 #136793;
        transform-origin: 50px 52px;
    }

    .loadingio-spinner-eclipse-yfpkut944xg {
        width: 200px;
        height: 200px;
        display: inline-block;
        overflow: hidden;
        background: none;
    }

    .ldio-d90oa551ckl {
        width: 100%;
        height: 100%;
        position: relative;
        transform: translateZ(0) scale(1);
        backface-visibility: hidden;
        transform-origin: 0 0;
        /* see note above */
    }

    .ldio-d90oa551ckl div {
        box-sizing: content-box;
    }

    /* generated by https://loading.io/ */
</style>